<app-pcbread-crumb [data]="breadCrumb"></app-pcbread-crumb>

<div
  id="warehouse-handling-page"
  class="card p-2 animate__animated"
  [ngClass]="cardClass"
  *ngIf="pageLoaded"
>
  <app-pctable-action
    [data]="action"
    [header]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable-action>

  <app-pctable
    [data]="data"
    [entityField]="fields"
    [urlName]="'columnsArray_warehouseHandlingReport'"
    (parentAction)="parentAction($event)"
  >
  </app-pctable>

  <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
  </app-pcpaging>

  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</div>

<ng-template #addModal let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "StartWarehouseHandling" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body border-bottom">
    <div class="row">
      <div class="col-12">
        <div class="edit-form">
          <div class="validation-alert-sale-buy">
            <p>{{ thisValue.stockMessage }}</p>
          </div>
          <label class="form-label label-size" for="count">
            {{ "stockName" | translate }}
          </label>
          <select
            id="stockName"
            class="form-select input-select-text py-2 Focusable iner-Focusable"
            [(ngModel)]="thisValue.stockId"
            [ngClass]="{
              'is-invalid':
                thisValue.stockMessage != '' && thisValue.stockMessage != null
            }"
          >
            <option Value="">
              {{ "SelectOne" | translate }}
            </option>
            <option *ngFor="let stock of stockList" [ngValue]="stock.id">
              {{ stock.persianName }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <app-loading-panel *ngIf="loading"></app-loading-panel>

  <div class="modal-footer justify-content-center p-2">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.dismiss('Cross click')"
    >
      <i class="bx bx-x"></i>
      {{ "Close" | translate }}
    </button>
    <button
      type="submit"
      class="btn btn-primary me-sm-3 me-1 data-submit"
      (click)="submitAdd()"
    >
      <i class="bx bx-check"></i>
      {{ "StartWarehouseHandling" | translate }}
    </button>
  </div>
</ng-template>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>

<app-pcconfrim-modal
  *ngIf="modalDeleteConfirm"
  (childEvent)="parentAction($event)"
  [inputModel]="confirmModal"
></app-pcconfrim-modal>

<ng-template #reportModal let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "WarehouseHandlingReport" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body border-bottom">
    <div class="row">
      <div class="col-3 my-2">
        <div class="card h-100">
          <div class="card-body text-center">
            <div class="row">
              <div class="col-3">
                <div class="avatar new-avatar mx-auto mb-2">
                  <span class="avatar-initial rounded-circle totalCount">
                    <i class="bx bx-hash"></i>
                  </span>
                </div>
              </div>
              <div class="col-9 text-start">
                <span class="d-block new-title text-nowrap pt-1">
                  {{ "totalCount" | translate }}
                </span>
              </div>
            </div>
            <h2 class="mb-n3">
              {{ thisReport?.totalCount | dataType : "" }}
            </h2>
          </div>
        </div>
      </div>
      <div class="col-3 my-2">
        <div class="card h-100">
          <div class="card-body text-center">
            <div class="row">
              <div class="col-3">
                <div class="avatar new-avatar mx-auto mb-2">
                  <span class="avatar-initial rounded-circle totalItemsCount">
                    <i class="bx bx-package"></i>
                  </span>
                </div>
              </div>
              <div class="col-9 text-start">
                <span class="d-block new-title text-nowrap pt-1">
                  {{ "totalItemsCount" | translate }}
                </span>
              </div>
            </div>
            <h2 class="mb-n3">
              {{ thisReport?.totalItemsCount | dataType : "" }}
            </h2>
          </div>
        </div>
      </div>
      <div class="col-3 my-2">
        <div class="card h-100">
          <div class="card-body text-center">
            <div class="row">
              <div class="col-3">
                <div class="avatar new-avatar mx-auto mb-2">
                  <span class="avatar-initial rounded-circle totalInventory">
                    <i class="bx bx-store"></i>
                  </span>
                </div>
              </div>
              <div class="col-9 text-start">
                <span class="d-block new-title text-nowrap pt-1">
                  {{ "totalInventory" | translate }}
                </span>
              </div>
            </div>
            <h2 class="mb-n3">
              {{ thisReport?.totalInventory | dataType : "" }}
            </h2>
          </div>
        </div>
      </div>
      <div class="col-3 my-2">
        <div class="card h-100">
          <div class="card-body text-center">
            <div class="row">
              <div class="col-3">
                <div class="avatar new-avatar mx-auto mb-2">
                  <span
                    class="avatar-initial rounded-circle totalInventoryAdjustmentCount"
                  >
                    <i class="bx bx-slider-alt"></i>
                  </span>
                </div>
              </div>
              <div class="col-9 text-start">
                <span class="d-block new-title text-nowrap pt-1">
                  {{ "totalInventoryAdjustmentCount" | translate }}
                </span>
              </div>
            </div>
            <h2 class="mb-n3">
              {{ thisReport?.totalInventoryAdjustmentCount | dataType : "" }}
            </h2>
          </div>
        </div>
      </div>
      <div class="col-3 my-2">
        <div class="card h-100">
          <div class="card-body text-center">
            <div class="row">
              <div class="col-3">
                <div class="avatar new-avatar mx-auto mb-2">
                  <span class="avatar-initial rounded-circle surplusCount">
                    <i class="bx bx-trending-up"></i>
                  </span>
                </div>
              </div>
              <div class="col-9 text-start">
                <span class="d-block new-title text-nowrap pt-1">
                  {{ "surplusCount" | translate }}
                </span>
              </div>
            </div>
            <h2 class="mb-n3">
              {{ thisReport?.surplusCount | dataType : "" }}
            </h2>
          </div>
        </div>
      </div>
      <div class="col-3 my-2">
        <div class="card h-100">
          <div class="card-body text-center">
            <div class="row">
              <div class="col-3">
                <div class="avatar new-avatar mx-auto mb-2">
                  <span class="avatar-initial rounded-circle shortageCount">
                    <i class="bx bx-trending-down"></i>
                  </span>
                </div>
              </div>
              <div class="col-9 text-start">
                <span class="d-block new-title text-nowrap pt-1">
                  {{ "shortageCount" | translate }}
                </span>
              </div>
            </div>
            <h2 class="mb-n3">
              {{ thisReport?.shortageCount | dataType : "" }}
            </h2>
          </div>
        </div>
      </div>
      <div class="col-3 my-2">
        <div class="card h-100">
          <div class="card-body text-center">
            <div class="row">
              <div class="col-3">
                <div class="avatar new-avatar mx-auto mb-2">
                  <span class="avatar-initial rounded-circle surplusItemsCount">
                    <i class="bx bx-layer-plus"></i>
                  </span>
                </div>
              </div>
              <div class="col-9 text-start">
                <span class="d-block new-title text-nowrap pt-1">
                  {{ "surplusItemsCount" | translate }}
                </span>
              </div>
            </div>
            <h2 class="mb-n3">
              {{ thisReport?.surplusItemsCount | dataType : "" }}
            </h2>
          </div>
        </div>
      </div>
      <div class="col-3 my-2">
        <div class="card h-100">
          <div class="card-body text-center">
            <div class="row">
              <div class="col-3">
                <div class="avatar new-avatar mx-auto mb-2">
                  <span
                    class="avatar-initial rounded-circle shortageItemsCount"
                  >
                    <i class="bx bx-layer-minus"></i>
                  </span>
                </div>
              </div>
              <div class="col-9 text-start">
                <span class="d-block new-title text-nowrap pt-1">
                  {{ "shortageItemsCount" | translate }}
                </span>
              </div>
            </div>
            <h2 class="mb-n3">
              {{ thisReport?.shortageItemsCount | dataType : "" }}
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-loading-panel *ngIf="modalLoading"></app-loading-panel>

  <div class="modal-footer justify-content-center p-2">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.dismiss('Cross click')"
    >
      <i class="bx bx-x"></i>
      {{ "Close" | translate }}
    </button>
  </div>
</ng-template>

<app-pcsetting-modal (parentAction)="parentAction($event)" [fields]="fields">
</app-pcsetting-modal>